import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Network } from "src/app/shared/model/network";
import { environment } from "src/environments/environment";

@Component({
    selector: "app-brands-section",
    templateUrl: "./brands-section.component.html",
    styleUrls: ["./brands-section.component.scss"],
})
export class BrandsSectionComponent implements OnInit {

    @ViewChild("list", { static: false }) list!: ElementRef;

    bucketBaseUrl: string;

    @Input()
    networks$: Observable<Network[]>;

    @Input()
    loadingNetworks: boolean;

    @Input()
    style: any;

    @Input()
    activateStyle: any;

    @Input()
    deactivateStyle: any;

    @Output()
    public clickNetwork = new EventEmitter<Network>();

    @Input() showActiveOnly: boolean = true;

    constructor(private router: Router) {
        this.bucketBaseUrl = environment.bucketUrlImagesNetworks;
    }

    getBucketImageUrl(fileName: string): string {
        return `${this.bucketBaseUrl}${fileName}`;
    }

    ngOnInit() {
        if (this.networks$) {
            this.networks$ = this.networks$.pipe(
                map(networks => networks.slice(0, 16))
            );
        }
    }

}
